import { Order } from '@luxuryescapes/contract-svc-order'
import { isMobileAppDevice } from 'lib/web/deviceUtils'
import { createSelector } from 'reselect'

/**
 * @see {@link Order.SourceApp}
 */
const getExperienceItemSourceApp = createSelector(
  (state: App.State) => isMobileAppDevice(state.system.rawUserAgentString),
  (state: App.State) => state.system.device.deviceType,
  (isMobileApp, deviceType): Order.SourceApp => {
    if (isMobileApp) {
      return 'mobile-app'
    } else if (deviceType === 'mobile') {
      return 'mobile-web'
    }
    return 'web'
  },
)

export default getExperienceItemSourceApp
